/**
 * epostaResimYukle — e-posta şablonlarının ve liste postalarının editörlerinde görsel yükleme (Bilge 2026-10-30, backend POST /email/templates/images).
 *
 * Editör görseli dosya olarak seçilince ya da sürüklenince bu eklenti onu backend'e yollar; backend `{ fileName, url, size }` döner ve editör `url`'yi görselin
 * adresi yapar. Adres OTURUMSUZ açılır, çünkü görseli postayı alanın posta programı çeker. Sunucuda `fds.mail.public-base-url` ayarlı olmalı; yoksa adres
 * yükleme isteğinin geldiği adrestir (kendi bilgisayarınızda yalnızca sizin makinenizde görünür, dışarıdaki bir alıcıda kırık görsel olur).
 * PNG, JPG, GIF, WEBP; boyut ve türler Sistem Ayarları › Dosya Ayarları'ndaki "E-posta şablonu görselleri" satırından. Reddi backend'in metnidir.
 *
 * Kullanım: editör ayarına `extraPlugins: [EpostaResimYuklemeEklentisi]`, plugins listesine ImageUpload (ve araç çubuğuna "insertImage").
 */
import axios from "axios";
import { JAVA_BACKEND_API_URL, getAuthHeader } from "../Components/Contexts/BackendConstants";
import { emailHatasi } from "./emailAyarService";

export const RESIM_YUKLEME_ADRESI = `${JAVA_BACKEND_API_URL}/email/templates/images`;

/** Dosyayı yükler; `{ fileName, url, size }` döner. Hata, backend'in kendi mesajıyla bir Error'dır. */
export async function epostaResmiYukle(dosya, signal) {
  const form = new FormData();
  form.append("file", dosya);
  try {
    const cevap = await axios.post(RESIM_YUKLEME_ADRESI, form, { headers: getAuthHeader(), signal });
    return cevap.data;
  } catch (error) {
    if (axios.isCancel(error)) throw error;
    throw emailHatasi(error);
  }
}

/** CKEditor'ün yükleme bağdaştırıcısı: `{ default: <adres> }` döner. */
export class EpostaResimYukleyici {
  constructor(loader) {
    this.loader = loader;
    this.controller = null;
  }

  async upload() {
    const dosya = await this.loader.file;
    this.controller = new AbortController();
    const veri = await epostaResmiYukle(dosya, this.controller.signal);
    return { default: veri.url };
  }

  abort() {
    if (this.controller) this.controller.abort();
  }
}

/** CKEditor eklentisi: `extraPlugins: [EpostaResimYuklemeEklentisi]`. */
export function EpostaResimYuklemeEklentisi(editor) {
  editor.plugins.get("FileRepository").createUploadAdapter = (loader) => new EpostaResimYukleyici(loader);
}
